'use client';
import { JumboCard, JumboScrollbar } from 'themes/jumbo/@jumbo/components';
import {
  Chip,
  Typography,
  Button,
  Fab,
  Tooltip,
  useTheme
} from '@mui/material';
import { ViewsList } from './components';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import {
    openHomeNewViewDialog
} from 'store/projects';
import { trackEvent } from "components/Tracking";
import { ViewType } from './components/ViewItem/types';
import { useState, useEffect } from "react";

const sortByDate = (a: ViewType, b: ViewType) => a.file_date && a.file_date > (b.file_date || '') ? 1 : -1;

const ViewsCard = ({title, sweetAlerts, filter}:{title:React.ReactNode, sweetAlerts: () => void, filter: string}) => {
	const _views = useSelector((state: any) => state.cache.data.views);
  const storeAuthData = useSelector((state: any) => state.auth);
  const { defaultProjects, hasActiveSubscription = false } = storeAuthData;
  const demoProjectsHidden = Number(localStorage.getItem('hideDemoProjects') || 0) > 0;
  const [views, setViews] = useState<any[]>([]);
  //const views = Object.values(_views).filter((item: any) => /*!demoProjectsHidden || */!defaultProjects.includes(item.project)) 
	const dispatch = useDispatch();
  const history = useHistory();
  const theme = useTheme();

  useEffect(() => {
    const data = Object.values(_views)
                        .sort((a:any, b:any) => sortByDate(a, b))
                        .filter((item: any) => !defaultProjects.includes(item.project))
                        .filter((item: any) => filter !== 'all' ? item.project === filter : item.project !== null);
    setViews(data);
  }, [_views, defaultProjects, filter])

  const handleAllClick = (e: any) => {
    trackEvent("Dashboard", "Views", "Btn_All");
    history.push(`/views`);
  };
  const handleDemosClick = (e: any) => {
    trackEvent("Dashboard", "Views", "Btn_All");
    history.push(`/views/tabs/demos`);
  };
  const addNewClick = (e: any) => {
    if(!hasActiveSubscription) {
      sweetAlerts();
      return;
    }
    dispatch(openHomeNewViewDialog(null));
    setTimeout(() => {
      history.push(`/views`);
    }, 250);
  };

  const CardTitle = () => (
    <div style={{display: "flex", justifyContent: 'space-between', height: '40px'}}>
      <div style={{display: "flex", gap: '10px', alignItems: 'center'}}>
        <Typography color={'text.primary'} variant={'h6'} mb={0}>
          {title}
        </Typography>
        <Chip
          size={'small'}
          label={views.length}
          color='success'
          sx={{
            textAlign: 'center',
            backgroundColor: theme.palette.primary.main,
            transform: 'scale(.8)'
          }}
        />
      </div>
      
      <div style={{display: "flex", gap: '10px', alignItems: 'center'}}>
        { views.length > 0 && (
          <Tooltip title="All Views" placement="top" arrow>
            <Button
              size={'small'}
              variant={'outlined'}
              onClick={handleAllClick} 
              style={{height: '25px', minWidth: 'auto'}}
            >
              All
            </Button>
          </Tooltip>
        )}
        { /* <Tooltip title="Demo Views" placement="top" arrow>
          <Button
            size={'small'}
            variant={'outlined'}
            onClick={handleDemosClick} 
            style={{height: '25px', minWidth: 'auto'}}
          >
            Demos
          </Button>
        </Tooltip> */ }
        <Tooltip title="Create New View" placement="top" arrow>
          <Fab
            size='small'
            aria-label='New View'
            onClick={(evt:any) => {
              trackEvent("Dashboard", "Views", "Btn_Plus")
              addNewClick(evt);
            }}
            sx={{
              color: 'common.white',
              bgcolor: '#5AADE3',
              //transform: 'scale(.7)',
              '&:hover': {
                bgcolor: '#2196f3',
              },
            }}
          >
            <AddIcon />
          </Fab>
        </Tooltip>
      </div>
    </div>
  )

  return (
    <JumboCard
      title={<CardTitle />}
      contentWrapper
      contentSx={{ p: 0 }}
    >
      <JumboScrollbar autoHeight autoHeightMin={284}>
        <ViewsList 
          views={views} 
          handleClick={(evt:any) => {
            trackEvent("Dashboard", "Views", "Btn_Create_New")
            addNewClick(evt);
          }}
        />
      </JumboScrollbar>
    </JumboCard>
  );
};

export { ViewsCard };
